"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function getCategoryAttributesForMparticle(csp) {
    var categories = orderedCategories(csp);
    return {
        category: getRootSlug(categories),
        subcategories: concatenatedCategorySlugs(categories),
    };
}
exports.getCategoryAttributesForMparticle = getCategoryAttributesForMparticle;
function orderedCategories(csp) {
    if (!csp) {
        return [];
    }
    var parentCategories = lodash_1.uniqWith(lodash_1.flatMap(csp.categories, function (cat) { return cat.parentCategories; }), lodash_1.isEqual);
    return parentCategories.concat(csp.categories);
}
exports.orderedCategories = orderedCategories;
function getRootSlug(categories) {
    var root = categories.find(function (c) { return !!lodash_1.get(c, 'rootSlug'); });
    return root && root.rootSlug || '';
}
function concatenatedCategorySlugs(categories) {
    if (lodash_1.some(categories, function (c) { return !c; }))
        return '';
    return categories.map(function (c) { return c.slug; }).join('|');
}
//# sourceMappingURL=csp_category_helper.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/csp_category_helper.js
// module id = tQbB
// module chunks = 20 21 22